import { LocalAudioTrack } from "twilio-video";
import { LocalAudioDelegator } from "../../../../core/room/participant/media/MediaDelegator";

export class TwilioLocalAudioDelegator implements LocalAudioDelegator {
  readonly kind = "audio" as const;
  #track: LocalAudioTrack;

  constructor(audioTrack: LocalAudioTrack) {
    this.#track = audioTrack;
  }

  get deviceId() {
    return this.#track.mediaStreamTrack.getSettings().deviceId;
  }

  get isEnabled() {
    return !!this.#track.isEnabled;
  }

  // Twilio-specific instance methods
  get track() {
    return this.#track;
  }
}
